import React from "react";
import ReactDOM from "react-dom/client"; // Note: client for React 18+
import App from "./app";
import "./i18n";
import { HelmetProvider } from 'react-helmet-async';


// This is the critical mounting point
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </HelmetProvider>,

);


